exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content--wrapper{background:#fff;padding:1rem;border-top:.25rem solid #9ecef3}.content--wrapper.has-tabs{border-top:0}@media screen and (min-width:47.5em){.content--wrapper{padding:1rem 2.25rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Content/Content.scss
// module id = 668
// module chunks = 0